import React, { useEffect, useState } from 'react'
import { Radio, Select, Input, Button, Space, Modal, message, Row, Col, Card } from 'antd'

import { observer } from '@/store'
import Store from './store'
import "./style.modules.scss"

import Control from "./control"


const App = ({ DevCode }) => {

  useEffect(() => {
    // console.log('[ DevCode ] >', DevCode)
  }, [])




  return (
    <div className='devicemange_css'>
      <Row gutter={[20, 25]}>
        {Store.list.map((v, k) =>
          <Col key={k} >
            <Control item={v} DevCode={DevCode} />
          </Col>)}


      </Row>

    </div>
  )
}

export default observer(App)
